import {
  type GetBookableExpertenByThemaOutput,
  type GetLocationsWithRaeumeOutput,
  type GetStandorteOutput,
  type PlanungsinformationFromThemaRouter,
} from '../../../dtos';
import {
  CalendarExperteResource,
  CalendarGruppenraumResource,
  CalendarSeminarraumResource,
  CalendarStandortResource,
} from './helperClasses';

export const createCalendarResources = (
  skipExperteGueltigkeitsCheck: boolean,
  expertepool: GetBookableExpertenByThemaOutput,
  locationsWithRaeume: GetLocationsWithRaeumeOutput,
  standorte: GetStandorteOutput,
  startDate: Date,
  planungsinformation?: PlanungsinformationFromThemaRouter,
) => {
  const seminarraumResources = [];
  const gruppenraumResources = [];
  const standortResources = [];
  const experteResources = [];

  for (const location of locationsWithRaeume) {
    for (const raum of location.seminarraeume) {
      seminarraumResources.push(new CalendarSeminarraumResource(raum, location));
    }
    for (const raum of location.gruppenraeume) {
      gruppenraumResources.push(new CalendarGruppenraumResource(raum, location));
    }
  }

  for (const experte of expertepool) {
    if (typeof planungsinformation === 'undefined') {
      throw new TypeError('[ResourceCalendar.utils] Experte resources require planungsinformation');
    }

    experteResources.push(
      new CalendarExperteResource(
        experte,
        startDate.getFullYear(),
        planungsinformation.expertePool,
        skipExperteGueltigkeitsCheck,
      ),
    );
  }

  for (const standort of standorte) {
    standortResources.push(new CalendarStandortResource(standort));
  }

  return { seminarraumResources, gruppenraumResources, standortResources, experteResources };
};
